import type { ProductReview } from '@/types/catalog/gallery'
import { VpStarRating } from '@vtmn-play/react/headless'
import { useTranslation } from 'react-i18next'
import './customer-reviews.scss'

export function CustomerReviews({
  review,
}: Readonly<{
  review: ProductReview
}>) {
  const { t } = useTranslation()

  return (
    <section className="customer-reviews" data-testid="customer-reviews">
      <VpStarRating
        score={review.average_rating}
        aria-label={t('products-page.product-card.reviews.score', { score: review.average_rating })}
      />
      <span className="reviews-count" data-testid="customer-reviews-count">
        {t('products-page.product-card.reviews.count', {
          count: review.total,
        })}
      </span>
    </section>
  )
}
